module.exports = __webpack_public_path__ + "static/media/start-transmission-icon.26be3b43.svg";